import React, { ComponentProps } from 'react'

import FormattedMarkdownMessage from 'components/FormattedMarkdownMessage'

import { FormattedMessage as T } from 'react-intl'
import { MessageKey } from 'types'

interface Props extends ComponentProps<typeof T> {
  markdown?: boolean
  id: MessageKey | string
}

const FormattedMessage: React.SFC<Props> = ({ markdown, ...props }) => {
  const Message = markdown ? FormattedMarkdownMessage : T

  return <Message {...props} />
}

export default FormattedMessage
